/* eslint-disable spaced-comment */
<template>
  <div class="popup">
    <!--    答对-->
    <div class="dialog" v-show="status === 'correct' && !lastQuestion">
      <div class="img">
        <img
          :src="
            $store.state.correctImg
              ? getImage($store.state.correctImg)
              : correct
          "
          alt
          style="height: 100%; width: 100%"
        />
      </div>
      <div class="button">
        <div class="home fl" @click="returnHome">
          <img
            :src="$store.state.themeImgs.length ? $store.state.themeImgs[0] : require('../assets/images/home.png')"
            alt
            style="height: 100%; width: 100%"
          />
        </div>
        <div class="next rg" @click="next">
          <img
            :src="$store.state.themeImgs.length ? $store.state.themeImgs[3] : require('../assets/images/next.png')"
            alt
            style="height: 100%; width: 100%"
          />
        </div>
      </div>
    </div>
    <!-- TODO:答对最后一题出现排名-->
    <div
      class="dialog rank-dialog"
      v-show="status === 'correct' && lastQuestion"
    >
      <div class="img">
        <img
          :src="
            $store.state.correctImg
              ? getImage($store.state.correctImg)
              : correct
          "
          alt
          style="height: 100%; width: 100%"
        />
      </div>
      <div class="rank">
        <div class="rank-content">现在排名：第{{ rank }}名</div>
        <p class="prize-hint" v-show="prizeHint">
          {{ prizeHint }}
        </p>
        <!-- <p>输入手机号保存战绩</p> -->
        <!-- 手机号验证 -->
        <!-- <input type="text" name="" id="" v-model="mobilePhone" /> -->
        <!-- <el-form
          :model="numberValidateForm"
          ref="numberValidateForm"
          class="demo-ruleForm"
        >
          <el-form-item
            prop="mobilePhone"
            :rules="[
              { required: true, message: '手机号不能为空' },
              {
                pattern: /^1[0-9]{10}$/,
                message: '手机号格式不对',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              type="mobilePhone"
              v-model.number="numberValidateForm.mobilePhone"
              autocomplete="off"
              maxlength="11"
              @blur.prevent="blurFun"
            ></el-input>
          </el-form-item>

        </el-form> -->
        <div class="button fail-button">
          <div class="home fl" @click="returnHome()" style="margin-top: 5px">
            <img
              :src="$store.state.themeImgs.length ? $store.state.themeImgs[1] : require('../assets/images/confirm.png')"
              alt
              style="height: 100%; width: 100%"
            />
          </div>
          <!-- <div
            class="next rg"
            @click="postGameRecord('numberValidateForm')"
            style="margin-top: 5px"
          >
            <img
              src="../assets/images/save.png"
              alt
              style="height: 100%; width: 100%"
            />
          </div> -->
        </div>
      </div>
    </div>
    <!-- 答错出现排名 -->
    <div
      class="dialog rank-dialog"
      v-show="status === 'error' || status === 'overtime'"
    >
      <div class="img">
        <img
          :src="$store.state.errorImg ? getImage($store.state.errorImg) : fail"
          alt
          style="height: 100%; width: 100%"
        />
      </div>
      <div class="rank">
        <div class="rank-content">现在排名：第{{ rank }}名</div>
        <!-- <p>输入手机号保存战绩</p> -->
        <!-- TODO:手机号验证 -->
        <!-- <input type="text" name="" id="" v-model="mobilePhone" /> -->
        <!-- <el-form
          :model="numberValidateForm"
          ref="numberValidateForm"
          class="demo-ruleForm"
        >
          <el-form-item
            prop="mobilePhone"
            :rules="[
              { required: true, message: '手机号不能为空' },
              {
                pattern: /^1[0-9]{10}$/,
                message: '手机号格式不对',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              type="mobilePhone"
              v-model.number="numberValidateForm.mobilePhone"
              autocomplete="off"
              maxlength="11"
              @blur.prevent="blurFun"
            ></el-input>
          </el-form-item>

        </el-form> -->
        <div class="button fail-button">
          <div class="home fl" @click="returnHome()" style="margin-top: 5px">
            <img
              :src="$store.state.themeImgs.length ? $store.state.themeImgs[1] : require('../assets/images/confirm.png')"
              alt
              style="height: 100%; width: 100%"
            />
          </div>
          <!-- <div
            class="next rg"
            @click="postGameRecord('numberValidateForm')"
            style="margin-top: 5px"
          >
            <img
              src="../assets/images/save.png"
              alt
              style="height: 100%; width: 100%"
            />
          </div> -->
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <!-- 手机登录 -->
    <div
      class="time-dialog dialog rank-dialog login-dialog newDialog"
      v-show="status === 'login' && platform === 'mobilePhone' && !isLogin"
    >
      <div class="time-title" :style="$store.state.themeImgs.length ? `background:url(${$store.state.themeImgs[6]}) 0 0/cover no-repeat` : ''"></div>
      <p>输入信息</p>
      <!-- TODO:手机号验证 -->
      <!-- <input type="text" name="" id="" v-model="mobilePhone" /> -->
      <el-form
        :model="numberValidateForm"
        ref="numberValidateForm"
        class="demo-ruleForm newFrom"
        label-width="2rem"
      >
        <el-form-item
          label="姓名"
          v-if="$store.state.showName"
          prop="name"
          :rules="[
            { required: true, message: '姓名不能为空' },
          ]"
        >
          <el-input v-model="numberValidateForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="单位"
          v-if="$store.state.showUnit"
          prop="unit"
          :rules="[
            { required: true, message: '单位不能为空' },
          ]"
        >
          <el-input v-model="numberValidateForm.unit"></el-input>
        </el-form-item>

        <el-form-item
          prop="mobilePhone"
          label="手机号"
          :rules="[
            { required: true, message: '手机号不能为空' },
            {
              pattern: /^1[3-9]\d{9}$/,
              message: '手机号格式不对',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="mobilePhone"
            v-model.number="numberValidateForm.mobilePhone"
            autocomplete="off"
            maxlength="11"
            @blur.prevent="blurFun"
          ></el-input>
          <p class="left-count" v-show="leftCount !== null">
            剩余{{ leftCount < 0 ? 0 : leftCount }}次答题机会
          </p>
        </el-form-item>
        <div class="login-button">
          <div
            class="confirm fl"
            @click="phoneEnterAnswer()"
            style="margin-top: 5px"
          >
            <img
              :src="$store.state.themeImgs.length ? $store.state.themeImgs[1] : require('../assets/images/confirm.png')"
              alt
              style="height: 100%; width: 100%"
            />
          </div>
          <div class="cancel rg" @click="closeDialog()" style="margin-top: 5px">
            <img
              :src="$store.state.themeImgs.length ? $store.state.themeImgs[2] : require('../assets/images/cancel.png')"
              alt
              style="height: 100%; width: 100%"
            />
          </div>
        </div>
      </el-form>
    </div>
    <!-- 一体机登录 -->
    <div
      class="time-dialog dialog rank-dialog login-dialog"
      v-show="status === 'login' && platform === 'gede'"
    >
      <div class="time-title" :style="$store.state.themeImgs.length ? `background:url(${$store.state.themeImgs[6]}) 0 0/cover no-repeat` : ''"></div>
      <p>输入手机号</p>
      <!-- TODO:手机号验证 -->
      <!-- <input type="text" name="" id="" v-model="mobilePhone" /> -->
      <el-form
        :model="numberValidateForm"
        ref="numberValidateForm"
        class="demo-ruleForm"
      >
        <el-form-item
          prop="mobilePhone"
          :rules="[
            { required: true, message: '手机号不能为空' },
            {
              pattern: /^1[3-9]\d{9}$/,
              message: '手机号格式不对',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            type="mobilePhone"
            v-model.number="numberValidateForm.mobilePhone"
            autocomplete="off"
            maxlength="11"
            @blur.prevent="blurFun"
          ></el-input>
          <p class="left-count" v-show="leftCount !== null">
            剩余{{ leftCount < 0 ? 0 : leftCount }}次答题机会
          </p>
        </el-form-item>
        <div class="login-button">
          <div
            class="confirm fl"
            @click="enterAnswer()"
            style="margin-top: 5px"
          >
            <img
              :src="$store.state.themeImgs.length ? $store.state.themeImgs[1] : require('../assets/images/confirm.png')"
              alt
              style="height: 100%; width: 100%"
            />
          </div>
          <div class="cancel rg" @click="closeDialog()" style="margin-top: 5px">
            <img
              :src="$store.state.themeImgs.length ? $store.state.themeImgs[2] : require('../assets/images/cancel.png')"
              alt
              style="height: 100%; width: 100%"
            />
          </div>
        </div>
      </el-form>
    </div>
    <!-- 不在游戏时间内 -->
    <div
      class="time-dialog dialog"
      v-show="status === 'nostart' || status === 'end'"
    >
      <div class="time-title" :style="$store.state.themeImgs.length ? `background:url(${$store.state.themeImgs[6]}) 0 0/cover no-repeat` : ''"></div>
      <p v-show="status === 'nostart'">活动未开始哦~</p>
      <p v-show="status === 'end'">活动已结束哦~</p>
      <div class="return-home" @click="closeDialog">
        <img
          :src="$store.state.themeImgs.length ? $store.state.themeImgs[0] : require('../assets/images/home.png')"
          alt
          style="height: 100%; width: 100%"
        />
      </div>
    </div>
    <!-- 答题次数用尽 -->
    <div class="time-dialog dialog" v-show="status === 'noLeftCount'">
      <div class="time-title" :style="$store.state.themeImgs.length ? `background:url(${$store.state.themeImgs[6]}) 0 0/cover no-repeat` : ''"></div>
      <p>您今日的答题次数已用尽~</p>
      <div class="return-home" @click="closeDialog">
        <img
          :src="$store.state.themeImgs.length ? $store.state.themeImgs[0] : require('../assets/images/home.png')"
          alt
          style="height: 100%; width: 100%"
        />
      </div>
    </div>
    <!--    确定返回首页-->
    <!-- <div class="dialog" v-show="status === 'return'">
      <div class="img">
        <img
          src="../assets/images/correct.jpg"
          alt=""
          style="height: 100%;width: 100%;"
        />
      </div>
      <p>返回首页后，需要从关卡1重新开始哦</p>
      <div class="button return">
        <div class="home fl" @click="returnHome">
          <img
            src="../assets/images/confirm2.png"
            alt=""
            style="height: 100%;width: 100%;"
          />
        </div>
        <div class="next rg" @click="confirmBack">
          <img
            src="../assets/images/cancely.png"
            alt=""
            style="height: 100%;width: 100%;"
          />
        </div>
      </div>
    </div>-->
    <!-- <div
      class="close"
      @click="returnHome"
      v-show="
        (status === 'error' ||
          (status === 'correct' && lastQuestion) ||
          status === 'overtime') &&
          rank <= 25
      "
    >
      <img
        src="../assets/images/close.png"
        alt
        style="width: 100%;height: 100%;"
      />
    </div> -->
  </div>
</template>

<script>
import correctImage from "@/assets/images/correct.jpg";
import errorImage from "@/assets/images/error.jpg";
import { mapState } from "vuex";

export default {
  name: "popup",
  props: ["status", "id", "time", "order", "lastQuestion", "rank"],
  data() {
    return {
      // status:this.props.status,//用户答题状态（correct、error、overtime、return）
      numberValidateForm: {
        mobilePhone: "", // 手机号
        name: '',
        unit: ''
      },
      rankList: [], // 排行榜
      correctImg: this.$store.state.correctImg,
      errorImg: this.$store.state.errorImg,
      correct: correctImage,
      fail: errorImage,
      canAnswer: false, //是否能进入答题
      leftCount: null, //剩余答题次数
      prizeHint: this.$store.state.prizeHint,
    };
  },
  // computed: {
  //   isLogin() {
  //     return this.$store.state.isLogin;
  //   },
  //   platform() {
  //     return this.$store.state.platform;
  //   },
  // },
  computed: mapState(["isLogin", "platform"]),
  methods: {
    returnHome() {
      this.$router.push({ name: "home" });
    },
    closeDialog() {
      this.$parent.closeDialog();
    },
    next() {
      this.$parent.changeOrder();
    },
    // 确认是否返回首页
    confirmBack() {
      this.$parent.changeStatus();
    },
    // 失焦时触发
    blurFun() {
      setTimeout(function () {
        let scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 300);
    },
    // 获取排行榜
    getRankList() {
      this.$http({
        url: this.$http.adornUrl("/api/game/front/record/" + this.id),
        method: "get",
      }).then((res) => {
        // console.log(res.data.data)
        this.rankList = res.data.data;
        // 本次游戏记录
        var myRecord = {
          crtTime: new Date().toLocaleString(),
          gameId: this.id,
          gameNumber:
            this.lastQuestion && this.status === "correct"
              ? this.order
              : this.order - 1,
          mobilePhone: this.numberValidateForm.mobilePhone,
          timeUsed: this.time,
        };
        // TODO:获取当前排名
        // 对数组进行重新排名
        this.rankList.push(myRecord);
        this.rankList.sort(function (a, b) {
          var aGameNumber = a.gameNumber;
          var bGameNumber = b.gameNumber;
          var aTimeUsed = a.timeUsed;
          var bTimeUsed = b.timeUsed;
          // console.log(aTimeUsed + ' | ' + bTimeUsed)

          if (aGameNumber === bGameNumber) {
            return aTimeUsed < bTimeUsed ? -1 : aTimeUsed > bTimeUsed ? 1 : 0;
          } else {
            return aGameNumber > bGameNumber ? -1 : 1;
          }
        });
        // 获取本次游戏排名
        function findIndex(l, o) {
          var objStr = JSON.stringify(o);
          return l.reduce((index, ele, i) => {
            if (JSON.stringify(ele) === objStr) {
              return i;
            } else {
              return index;
            }
          }, -1);
        }
        console.log(findIndex(this.rankList, myRecord) + 1);
        this.rank = findIndex(this.rankList, myRecord) + 1;
      });
    },
    //获取当前排名
    getNowRank() {
      this.$http(this.$http.adornUrl("/api/game/front/rank"), {
        params: {
          gameId: this.id, // 游戏id
          gameNumber:
            this.lastQuestion && this.status === "correct"
              ? this.order
              : this.order - 1,
          timeUsed: this.time,
        },
      }).then((res) => {
        console.log(res.data.data);
        this.rank = res.data.data;
      });
    },
    // 提交记录
    postGameRecord(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl("/api/game/front/gameRecord"),
            data: {
              mobilePhone: this.numberValidateForm.mobilePhone,
              gameNumber:
                this.lastQuestion && this.status === "correct"
                  ? this.order
                  : this.order - 1,
              timeUsed: this.time,
              gameId: this.id,
            },
            method: "post",
          }).then((res) => {
            console.log(res.data);
            // alert(res.data.message)
            var _this = this;
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              center: true,
              callback: () => {
                if (res.data.status === 200) {
                  _this.$router.push({
                    name: "home",
                    params: { view: true },
                  });
                }
              },
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getImage(image) {
      return window.SITE_CONFIG.imageRootUrl + image;
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(
              `/api/game/front/game-record/phone?mobilePhone=${
                this.numberValidateForm.mobilePhone ||
                this.$store.state.phoneNumber
              }&gameId=${this.$store.state.id}&name=${this.numberValidateForm.name}&unit=${this.numberValidateForm.unit}`

            ),
            method: "post",
          }).then((res) => {
            if (!res.data.rel && res.data.data == '该账号状态存在异常') {
              return alert(res.data.data)
            }
            console.log(res.data);
            // alert(res.data.message)
            this.$store.state.submitLimit
              ? (this.leftCount = this.$store.state.submitLimit - res.data.data)
              : null;
            var _this = this;
            if (res.data.status === 200 && res.data.rel) {
              _this.canAnswer = true;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      this.$store.state.phoneNumber = this.numberValidateForm.mobilePhone;
      console.log(
        this.numberValidateForm.mobilePhone,
        this.$store.state.phoneNumber
      );
    },
    getLeftCount() {
      // 
      // document.cookie = `${this.$store.state.gameCode}_phoneNumber=${this.$store.state.phoneNumber};max-age=3600`;
      // console.log('isLogin', this.$store.state.isLogin)
      // this.$cookie.set('zjsb_phoneNumber', this.$store.state.phoneNumber)
      this.$http({
        url: this.$http.adornUrl(
          `/api/game/front/game-record/phone?mobilePhone=${this.$store.state.phoneNumber
          }&gameId=${this.$store.state.id}`
        ),
        method: "post",
      }).then((res) => {
        if (!res.data.rel && res.data.data == '该账号状态存在异常') {
          // return alert(res.data.data)
          return this.leftCount = '该账号状态存在异常'
        }
        // alert(res.data.message)
        console.log(this.$store.state.submitLimit - res.data.data)
        this.$store.state.submitLimit
          ? (this.leftCount = `您的答题次数剩余${this.$store.state.submitLimit - res.data.data}次`)
          : (this.leftCount = '欢迎进入游戏');
        console.log(this.leftCount)
        var _this = this;
        if (res.data.status === 200 && res.data.rel) {
          _this.canAnswer = true;
        }
      });
    },
    enterAnswer() {
      console.log("一体机进入");
      this.canAnswer
        ? this.$router.push({
            name: "answer",
          })
        : null;
    },
    phoneEnterAnswer() {
      if (this.canAnswer) {
        console.log("手机进入");
        if (this.$store.state.showName) {
          if (!this.numberValidateForm.name) return this.$alert('请输入姓名')
          this.$cookie.set('name', this.numberValidateForm.name)
        }
        if (this.$store.state.showUnit) {
          if (!this.numberValidateForm.unit) return this.$alert('请输入单位')
          this.$cookie.set('unit', this.numberValidateForm.unit)
        }

        document.cookie = `${this.$store.state.gameCode}_phoneNumber=${this.numberValidateForm.mobilePhone};max-age=3600`;
        this.$store.state.isLogin = true;
        this.$router.push({
          name: "answer",
        });
      }
    },
  },
  mounted() {
    console.log(this.lastQuestion);
  },
  watch: {
    numberValidateForm: {
      handler() {
        console.log(this.numberValidateForm.mobilePhone.toString().length);
        this.leftCount = null;
        if (this.numberValidateForm.mobilePhone.toString().length === 11) {
          console.log("需要提交");
          this.login("numberValidateForm");
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$small: 375px;
$medium: 1079px;
$big: 1921px;
.fl {
  float: left;
}
.rg {
  float: right;
}
.infoTitle{
  width: 2rem;
  // height: 1rem;
  color: #434142;
  font-size: 0.4rem;
}
.infoInput{
  width: 4rem;
}
.infoItem{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.1rem;
}
.popup .newFrom .el-form-item__label{
  font-size: 0.5rem;
  color: #434142;
  padding-right: 0.1rem;
  white-space:pre-wrap;
  padding-left: 0.3rem;
  text-align: justify;
  height: 1rem;
}
.popup .newFrom .el-form-item__label:before{
  content: none !important;
}
.popup .newFrom .el-form-item label:after {
  content: "";
  display: inline-block;
  width: 100%;
}

.newDialog{
  height: unset !important;
}
.popup .time-dialog .inputCode input{
  width: 100%;
}
.popup .el-form-item__content{
  margin-bottom: 0.2rem;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .dialog {
    position: relative;
    top: 50%;
    left: 50%;
    // margin-left: -3.703rem;
    // margin-top: -4.377rem;
    width: 7.407rem;
    height: 8.704rem;
    background-color: #fff;
    border-radius: 10px;
    transform: translate(-50%, -50%);
    overflow: hidden;
    .img {
      width: 7.407rem;
      height: 6.537rem;
    }
    .congratulation {
      width: 7.407rem;
      height: 5.898rem;
    }
    p {
      margin: 0.222rem 0 0.296rem 0;
      font-size: 0.241rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.463rem;
      letter-spacing: 0.024rem;
      color: #fff;
    }
    .title1 {
      margin: 0.472rem 0 0.574rem 0;
      font-size: 0.435rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.463rem;
      letter-spacing: 0.044rem;
      color: #333333;
    }
    .button {
      width: 6rem;
      height: 0.667rem;
      margin: 0.7rem auto 0 auto;
      .home {
        width: 2.778rem;
        height: 0.833rem;
        display: inline-block;
        // img:active {
        //   filter: url(#change);
        // }
      }
      .next {
        width: 2.778rem;
        height: 0.833rem;
        display: inline-block;
        // img:active {
        //   filter: url(#change);
        // }
      }
    }
    .fail-button {
      width: 2.778rem;
      margin: 0.36rem auto 0 auto;
    }
    .return {
      margin: 0 auto;
    }
  }
  .rank-dialog {
    height: auto;
    padding-bottom: 0.3rem;
    .rank {
      height: 1.852rem;
      width: 100%;
      .rank-content {
        width: 6.111rem;
        height: 0.463rem;
        margin: 0.6rem auto 0 auto;
        // background: url("../assets/images/nowrank.png") 0 0 / contain no-repeat;
        font-family: PingFangSC-Regular;
        font-size: 0.463rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.463rem;
        letter-spacing: 0.037rem;
        color: #434142;
        // text-indent: 6.5em;
      }
      p {
        margin: 0.361rem auto 0.278rem auto;
        font-family: PingFangSC-Regular;
        font-size: 0.37rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.463rem;
        letter-spacing: 0.024rem;
        color: #fff;
      }
      .prize-hint {
        margin: 20px 0;
        font-size: 0.5rem;
        color: #870013;
        line-height: 0.8rem;
        padding: 0 0.1rem;
      }
      input {
        width: 4.63rem;
        height: 0.556rem;
        border-radius: 0.046rem;
        border: solid 1px #fff;
        font-family: PingFangSC-Regular;
        font-size: 0.241rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.463rem;
        letter-spacing: 0.024rem;
        color: #fff;
      }
      .el-form-item__error {
        left: 20%;
        top: 75%;
      }
      .el-form {
        @media screen and (max-width: $medium) {
          .el-form-item {
            margin-bottom: 0;
          }
          .button {
            margin: 0 auto;
          }
        }
      }
    }
  }
  .time-dialog {
    position: relative;
    top: 40%;
    left: 50%;
    // margin-left: -3.703rem;
    // margin-top: -2rem;
    width: 7.407rem;
    height: 4rem;
    background-color: #fff;
    border-radius: 0.046rem;
    .time-title {
      height: 0.8rem;
      width: 100%;
      background-image: linear-gradient(90deg, #005ab7 0%, #00299f 100%),
        linear-gradient(#870013, #870013);
      background-blend-mode: normal, normal;
    }
    p {
      font-size: 0.4rem;
      color: #434142;
      margin-top: 1rem;
    }
    .return-home {
      width: 2rem;
      height: 0.648rem;
      margin: 0.5rem auto 0 auto;
      img {
        height: 100%;
        width: 100%;
      }
    }
    input {
      width: 4.63rem;
      height: 0.8rem;
      border-radius: 0.046rem;
      border: solid 1px #434142;
      font-family: PingFangSC-Regular;
      font-size: 0.5rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.8rem;
      letter-spacing: 0.024rem;
      color: #434142;
    }
    .el-form-item__error {
      left: 20%;
      top: 75%;
    }
    .el-form {
      @media screen and (max-width: $medium) {
        .el-form-item {
          margin-bottom: 0;
        }
        .button {
          margin: 0 auto;
        }
      }
    }
  }
  .login-dialog {
    height: 5rem;
    p {
      font-size: 0.5rem;
      margin-top: 0.8rem;
    }
    .left-count {
      font-size: 0.4rem;
      line-height: 0.5rem;
      margin: 0;
      color: #870013;
    }
    .login-button {
      height: 1.2rem;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      > div {
        width: 2.778rem;
        height: 0.833rem;
      }
    }
  }
}
.el-message-box {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 5rem !important;
  height: 3rem;
  margin-left: -2.5rem;
  margin-top: -1.5rem;
  border-radius: 10px;
  background-color: #eae4da !important;
  .el-message-box__message {
    p {
      font-size: 0.5rem;
      color: #fff;
    }
  }

  .el-button {
    background-color: #fff !important;
    border-color: #fff !important;
    margin-top: 0.8rem;
    // width: 2rem;
    // height: 1rem;
    // border-radius: 10px;
    width: 2.778rem;
    height: 0.926rem;
    letter-spacing: 0.046rem;
    // background-color: #ffffff;
    border-radius: 0.463rem;
    padding: 9px 27px !important;
    // background: url(../assets/images/confirm.png) 100% 100% no-repeat;
    span {
      display: block;
      text-align-last: justify;
      font-size: 0.4rem;
      color: #fff;
    }

    @media screen and (min-width: $small) and (max-width: $medium) {
      margin-top: 0.1rem;
    }
    @media screen and (min-width: 1081px) and (max-width: $big) {
      margin-top: 0.5rem;
    }
  }
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #47332a;
}
</style>



// WEBPACK FOOTER //
// src/components/popup.vue